import { createTypographyVariant } from "../../utils/createTypographyVariant";

export const Body1RegularTypography = createTypographyVariant(
  "body",
  1,
  "regular"
);
export const Body2RegularTypography = createTypographyVariant(
  "body",
  2,
  "regular"
);
export const Body3RegularTypography = createTypographyVariant(
  "body",
  3,
  "regular"
);
export const Body4RegularTypography = createTypographyVariant(
  "body",
  4,
  "regular"
);
export const Body5RegularTypography = createTypographyVariant(
  "body",
  5,
  "regular"
);
export const Body6RegularTypography = createTypographyVariant(
  "body",
  6,
  "regular"
);

export const Body1MediumTypography = createTypographyVariant(
  "body",
  1,
  "medium"
);
export const Body2MediumTypography = createTypographyVariant(
  "body",
  2,
  "medium"
);
export const Body3MediumTypography = createTypographyVariant(
  "body",
  3,
  "medium"
);
export const Body4MediumTypography = createTypographyVariant(
  "body",
  4,
  "medium"
);
export const Body5MediumTypography = createTypographyVariant(
  "body",
  5,
  "medium"
);
export const Body6MediumTypography = createTypographyVariant(
  "body",
  6,
  "medium"
);

export const Caps1SemiboldTypography = createTypographyVariant(
  "caps",
  1,
  "semiBold"
);
export const Caps2SemiboldTypography = createTypographyVariant(
  "caps",
  2,
  "semiBold"
);
export const Caps1BoldTypography = createTypographyVariant("caps", 1, "bold");
export const Caps2BoldTypography = createTypographyVariant("caps", 2, "bold");
export const Caps1ExtraBoldTypography = createTypographyVariant(
  "caps",
  1,
  "extraBold"
);
export const Caps2ExtraBoldTypography = createTypographyVariant(
  "caps",
  2,
  "extraBold"
);

export const Heading1SemiboldTypography = createTypographyVariant(
  "heading",
  1,
  "semiBold"
);
export const Heading2SemiboldTypography = createTypographyVariant(
  "heading",
  2,
  "semiBold"
);
export const Heading3SemiboldTypography = createTypographyVariant(
  "heading",
  3,
  "semiBold"
);
export const Heading4SemiboldTypography = createTypographyVariant(
  "heading",
  4,
  "semiBold"
);
export const Heading5SemiboldTypography = createTypographyVariant(
  "heading",
  5,
  "semiBold"
);
export const Heading6SemiboldTypography = createTypographyVariant(
  "heading",
  6,
  "semiBold"
);

export const Heading0ExtraBoldTypography = createTypographyVariant(
  "heading",
  0,
  "extraBold"
);
export const Heading1BoldTypography = createTypographyVariant(
  "heading",
  1,
  "bold"
);
export const Heading2BoldTypography = createTypographyVariant(
  "heading",
  2,
  "bold"
);
export const Heading3BoldTypography = createTypographyVariant(
  "heading",
  3,
  "bold"
);
export const Heading4BoldTypography = createTypographyVariant(
  "heading",
  4,
  "bold"
);
export const Heading5BoldTypography = createTypographyVariant(
  "heading",
  5,
  "bold"
);
export const Heading6BoldTypography = createTypographyVariant(
  "heading",
  6,
  "bold"
);

export const Heading1ExtraBoldTypography = createTypographyVariant(
  "heading",
  1,
  "extraBold"
);
export const Heading2ExtraBoldTypography = createTypographyVariant(
  "heading",
  2,
  "extraBold"
);
export const Heading3ExtraBoldTypography = createTypographyVariant(
  "heading",
  3,
  "extraBold"
);
export const Heading4ExtraBoldTypography = createTypographyVariant(
  "heading",
  4,
  "extraBold"
);
export const Heading5ExtraBoldTypography = createTypographyVariant(
  "heading",
  5,
  "extraBold"
);
export const Heading6ExtraBoldTypography = createTypographyVariant(
  "heading",
  6,
  "extraBold"
);

export const SerifHeading1BoldTypography = createTypographyVariant(
  "serif-heading",
  1,
  "bold"
);
export const SerifHeading2BoldTypography = createTypographyVariant(
  "serif-heading",
  2,
  "bold"
);
export const SerifHeading3BoldTypography = createTypographyVariant(
  "serif-heading",
  3,
  "bold"
);
export const SerifHeading4BoldTypography = createTypographyVariant(
  "serif-heading",
  4,
  "bold"
);
